import React, { useState } from "react";
import { useMountEffect } from "../../../hooks/LifeCycle";
import VoucherAutorizacion from "../components/VoucherAutorizacion";
import { connect } from "react-redux";

const VoucherGmmScreen = (props) => {
  const [dataAutorizacion, setDataAutorizacion] = useState(null);

  const [procedimientos, setProcedimientos] = useState([]);

  const [numeroAutorizacion, setNumeroAutorizacion] = useState([]);

  const [isVoucherMatricial, setIsVoucherMatricial] = useState(false);

  useMountEffect(() => {
    const {
      dataAutorizacion,
      procedimientos,
      numeroAutorizacion,
      isMatricial,
    } = props.getVoucherGmmData?.voucherGmmDataInfo;

    setNumeroAutorizacion(numeroAutorizacion);

    setDataAutorizacion(dataAutorizacion);

    setProcedimientos(procedimientos);

    setIsVoucherMatricial(isMatricial);
  });

  return (
    <VoucherAutorizacion
      numeroAutorizacion={numeroAutorizacion}
      dataAutorizacion={dataAutorizacion}
      procedimientos={procedimientos}
      isVoucherMatricial={isVoucherMatricial}
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  getVoucherGmmData: state.voucher.getVoucherGmmData,
  getVoucherGmmLoading: state.voucher.getVoucherGmmLoading,
  getVoucherGmmError: state.voucher.getVoucherGmmError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(VoucherGmmScreen);
